(() => {
  const header = document.querySelector("[data-grpl-header]");
  const menuButton = document.querySelector("[data-grpl-menu-button]");
  const mobileMenu = document.querySelector("[data-grpl-mobile-menu]");

  const setMenu = (open) => {
    if (!menuButton || !mobileMenu) return;
    menuButton.setAttribute("aria-expanded", String(open));
    mobileMenu.setAttribute("aria-hidden", String(!open));
    mobileMenu.classList.toggle("is-open", open);
    document.body.classList.toggle("grpl-menu-open", open);
    if (open) header?.classList.remove("is-hidden");
  };

  menuButton?.addEventListener("click", () => {
    setMenu(menuButton.getAttribute("aria-expanded") !== "true");
  });

  mobileMenu?.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => setMenu(false));
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") setMenu(false);
  });

  if (header) {
    let lastScrollY = window.scrollY;
    let ticking = false;

    const updateHeader = () => {
      const currentScrollY = window.scrollY;
      const delta = currentScrollY - lastScrollY;
      const isMobile = window.matchMedia("(max-width: 1100px)").matches;
      const menuIsOpen = menuButton?.getAttribute("aria-expanded") === "true";

      if (!isMobile || menuIsOpen || currentScrollY <= 24) {
        header.classList.remove("is-hidden");
      } else if (delta > 5 && currentScrollY > header.offsetHeight) {
        header.classList.add("is-hidden");
      } else if (delta < -5) {
        header.classList.remove("is-hidden");
      }

      lastScrollY = currentScrollY;
      ticking = false;
    };

    const requestHeaderUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateHeader);
    };

    window.addEventListener("scroll", requestHeaderUpdate, { passive: true });
    window.addEventListener("resize", requestHeaderUpdate);
  }

  document.querySelectorAll(".grpl-faq details").forEach((detail) => {
    detail.addEventListener("toggle", () => {
      if (!detail.open) return;
      detail.parentElement
        ?.querySelectorAll("details[open]")
        .forEach((other) => {
          if (other !== detail) other.removeAttribute("open");
        });
    });
  });
})();
